module.exports = __webpack_public_path__ + "img/icon-c-depos-ls.439caf22.png";